import * as React from 'react';
import styled from '@emotion/styled';
import { useSystem } from '../../../hooks/useSystem';
import { ProfileRoutes } from '@foxbun/lib-goferal-types';
import { SimpleImageForm } from './SimpleImageForm';
import { Notification, NotificationType } from '../../../core/stores/NotificationStore';
import { AnimatePageWidget } from '../../../widgets/layout/AnimatePageWidget';
import { APP_ENV } from '../../../env';

export const EditAvatarPage: React.FC = () => {
  const system = useSystem();
  return (
    <AnimatePageWidget slide={true}>
      <S.Container>
        <SimpleImageForm
          aspect_ratio={1}
          label="Upload avatar"
          handle={async ({ file, crop, upload }) => {
            let token = await system.session.token_wrapper.getToken();
            await upload.send(`${APP_ENV.API_SERVER}${ProfileRoutes.UPLOAD_PROFILE_IMAGE}`, token, crop);
            await system.user.refresh();
            system.notification_store.showNotification(
              new Notification({
                type: NotificationType.SUCCESS,
                desc: 'Profile image updated'
              })
            );
          }}
        ></SimpleImageForm>
        <SimpleImageForm
          aspect_ratio={1}
          label="Upload Header"
          handle={async ({ file, crop, upload }) => {
            let token = await system.session.token_wrapper.getToken();
            await upload.send(`${APP_ENV.API_SERVER}${ProfileRoutes.UPLOAD_HEADER_IMAGE}`, token, crop);
            await system.user.refresh();
            system.notification_store.showNotification(
              new Notification({
                type: NotificationType.SUCCESS,
                desc: 'Header image updated'
              })
            );
          }}
        ></SimpleImageForm>
      </S.Container>
    </AnimatePageWidget>
  );
};
namespace S {
  export const Container = styled.div`
    display: flex;
    align-items: stretch;
    flex-direction: column;
    row-gap: 10px;
    overflow: auto;
    margin: auto;
    height: 100%;
    width: 100%;
    max-width: 400px;
    padding: 10px;
    box-sizing: border-box;
  `;
}
